import { useTrans } from "@/translations";

import React, { useMemo } from "react";

type Props = {
  nrErrors: number;
};

export const ErrorTag: React.FC<Props> = ({ nrErrors }) => {
  const { t } = useTrans();

  const text = useMemo(() => {
    if (nrErrors === 1) {
      return t("errors:error").toLowerCase();
    }

    return t("errors:errors");
  }, [nrErrors, t]);

  return (
    <div className="bg-light-peach text-carrot-red rounded-full px-3 py-0.5 text-xs font-medium whitespace-nowrap">
      {nrErrors} {text}
    </div>
  );
};
